import { getLogger } from '@/modules/observability/logging';

export function useClipboard({
  componentName,
}: { componentName?: string } = {}) {
  const logger = getLogger();

  async function copyToClipboard(text: string) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error: unknown) {
      logger.error('Clipboard API error', {
        componentName: componentName ?? 'N/A',
        // Throws DOMException only as per https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/write#exceptions
        errorMessage: error instanceof DOMException ? error.message : error,
      });
    }
  }

  async function readFromClipboard(): Promise<string | null> {
    try {
      return await navigator.clipboard.readText();
    } catch (error: unknown) {
      logger.error('Clipboard API error', {
        componentName: componentName ?? 'N/A',
        errorMessage: error instanceof DOMException ? error.message : error,
      });
      return null;
    }
  }

  return { copyToClipboard, readFromClipboard };
}
